import React from 'react';
import WorkProject from '../components/WorksProject';
import LiquidObject from '../components/common/LiquidObject';

const WorksPage = () => {
  return (
    <>
      <WorkProject />
      {/* Liquid Object */}
      <LiquidObject />
    </>
  );
};

export default WorksPage;
